import { db, admin } from 'common/config/Firebase'
import { pad } from 'common/services/util'
import { v4 as uuidv4 } from 'uuid'

const addDeviceFromPortalUseCase = async (client, deviceData) => {
    const paramsRef = db.collection('params').doc('task')

    // Obtener y reservar el número de referencia de forma atómica
    let reference
    await db.runTransaction(async (t) => {
        const doc = await t.get(paramsRef)
        const count = doc.data().count
        reference = pad(count, 4)
        t.update(paramsRef, { count: admin.firestore.FieldValue.increment(1) })
    })

    const now = Date.now()
    const task = {
        reference,
        dni: client.id,
        clientName: client.name || '',
        phone: client.phone || '',
        mail: client.mail || '',
        deviceName: deviceData.deviceName || '',
        imei: deviceData.imei || '',
        unlockCode: deviceData.unlock || '',
        refClient: deviceData.refClient || '',
        description: deviceData.description || '',
        budget: '',
        state: 7,
        payed: 0,
        invoiced: 0,
        dateEntry: now,
        dateEntrySign: now,
        shippingEnabled: deviceData.shipping || false,
        shippingStatus: deviceData.shipping ? 1 : 0,
        fromPortal: true,
        iva: client.iva !== false,
    }

    const docRef = await db.collection('tasks').add(task)

    if (deviceData.observations && deviceData.observations.trim()) {
        await db.collection('tasksDetail').doc(docRef.id).set({
            observations: [{
                id: uuidv4(),
                message: deviceData.observations.trim(),
                date: now,
            }]
        })
    }

    return { id: docRef.id, ...task }
}

export default addDeviceFromPortalUseCase
